import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcFolderOpen32 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 32,
	viewBox: "0 0 32 32",
	width: 32,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m14.5 5c.217 0 .482.067.737.319l3.678 3.681h6.085c1.598 0 3 1.29 3 3.027v1.3c.973.495 1.85 1.68 1.596 3.166l-1.331 8a3.004 3.004 0 0 1 -2.791 2.507h-18.78a3.01 3.01 0 0 1 -2.959-2.507l-1.333-8a3.001 3.001 0 0 1 1.597-3.167l.001-5.326c0-1.598 1.29-3 3-3zm-9.177 10.007c-.631.043-1.032.526-.945 1.204l1.33 7.953a1 1 0 0 0 .866.829l18.732.007c.448 0 .901-.328.986-.836l1.328-7.953c.09-.725-.365-1.144-.92-1.204zm8.762-8.007h-7.085c-.513 0-1 .406-1 1v5h20v-1c0-.513-.425-.963-1-1h-6.5c-.221 0-.516-.096-.707-.293z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcFolderOpen32;
